var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable react-hooks/exhaustive-deps */
import { DefaultInputProps } from '../model/DefaultInputProps';
import React, { useEffect, useMemo, useState } from 'react';
import { HandleError } from '../modules/utils/HandleError';
import { MunicipiosOrigemApi } from '../apis/municipios-origem-api';
import { DefaultAutoComplete } from './DefaultAutoComplete';
var MunicipioOrigemSelectorProps = /** @class */ (function (_super) {
    __extends(MunicipioOrigemSelectorProps, _super);
    function MunicipioOrigemSelectorProps() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return MunicipioOrigemSelectorProps;
}(DefaultInputProps));
export { MunicipioOrigemSelectorProps };
export var MunicipioOrigemSelector = function (_a) {
    var _b = _a.placeholder, placeholder = _b === void 0 ? "Selecione um Munic\u00EDpio" : _b, _c = _a.fieldName, fieldName = _c === void 0 ? 'denominacao' : _c, onMunicipiosChange = _a.onMunicipiosChange, noOptionsText = _a.noOptionsText, defaultValue = _a.defaultValue, fieldError = _a.fieldError, refChange = _a.refChange, onChange = _a.onChange, required = _a.required, disabled = _a.disabled, label = _a.label, value = _a.value, name = _a.name;
    //region Constants
    var _d = useState("".concat(crypto.getRandomValues(new Uint8Array(16)))), key = _d[0], setKey = _d[1];
    var _e = useState([]), municipios = _e[0], setMunicipios = _e[1];
    var _f = useState(), error = _f[0], setError = _f[1];
    //endregion
    //region Hooks
    useEffect(function () {
        handleSearchMun();
        setKey("".concat(crypto.getRandomValues(new Uint8Array(16))));
    }, []);
    useEffect(function () {
    }, [value, key, fieldError]);
    useEffect(function () {
        if (onMunicipiosChange) {
            onMunicipiosChange(__spreadArray([], municipios, true));
        }
    }, [municipios]);
    //endregion
    //region Handles
    var municipiosMemo = useMemo(function () {
        return municipios;
    }, [municipios]);
    var handleCloseError = function () {
        setError(undefined);
    };
    var handleSearchMun = function () {
        MunicipiosOrigemApi.getMunicipiosOrigem()
            .then(function (response) { return handleLoadMunicipio(response); })
            .catch(function (err) { return setError(err); });
    };
    var handleLoadMunicipio = function (response) {
        if (defaultValue) {
            setMunicipios(__spreadArray([defaultValue], response, true));
        }
        else {
            setMunicipios(response);
        }
    };
    //endregion
    return (_jsxs(_Fragment, { children: [_jsx(DefaultAutoComplete, { onChange: function (newValue) { return onChange(newValue); }, noOptionsText: noOptionsText !== null && noOptionsText !== void 0 ? noOptionsText : 'Nenhum município de origem encontrado.', refChange: refChange !== null && refChange !== void 0 ? refChange : municipiosMemo, fieldsList: municipiosMemo, defaultValue: defaultValue, placeholder: placeholder, fieldError: fieldError, value: value || null, name: name, fieldName: fieldName, disabled: disabled, required: required, label: label }), _jsx(HandleError, { error: error, handleClose: handleCloseError })] }));
};
